module.exports = __webpack_public_path__ + "static/909-e8f4611aff348c395be4ccb1d84852c3.png";